<template>
	<div class="container p-0">
		<div :data-bs-theme='reservation.venueParams.resource_id' class="card">
			<div class="card-header">
				<h3>{{ reservation.venueParams.business_name }}</h3>
			</div>
			<div class="row g-0">
				<div class="col-lg-4 align-items-center h-100">
					<div class="info-inblock info-inblock-primary">
						<div>{{ date }}</div>
						<div class="vr-point"></div>
						<div>{{ time }} h</div>
						<div class="vr-point"></div>
						<div>{{ reservation.pax }} Pers</div>
					</div>
					<div class="info-inblock info-inblock-black">
						<div class="info-reservation-name" data-bs-toggle="tooltip" data-bs-placement="top" :data-bs-title="invitedUsersString" type="button">
							{{ reservation.name }} <span class="mx-1">+</span>
							<div id="guests" v-if="invitedUsers.length">
								<span>{{ displayInvitedUsers }}</span>
							</div>
							<div v-else>
								No hay asistentes
							</div>

						</div>
					</div>

					<div class="hidden display-md">
						<ul class="list-group list-group-flush">
							<li class="list-group-item">
								<div v-if="isCreator && !reservation.finishedDateTime && reservation.menuAccessEnabled !== 1" class="col-12">
									<a :data-bs-target="'#modalUpdateReserve-' + reservation.id" class="btn btn-outline-primary w-100" data-bs-toggle="modal">
										Modificar reserva
									</a>
								</div>
							</li>
							<li class="list-group-item">
								<a :data-bs-target="'#modalGoogleMaps-' + reservation.id" data-bs-toggle="modal" class="btn btn-outline-primary w-100 h-100 align-content-center">
									<i class="fas fa-map-marker-alt"></i> Cómo llegar
								</a>
							</li>
							<li class="list-group-item">
								<a v-if="isCreator && !reservation.finishedDateTime && reservation.menuAccessEnabled !== 1" id="btn-cancel-reservation" :data-bs-target="'#modalCancelReserve-' + reservation.id" class="btn btn-outline-primary w-100" data-bs-toggle="modal">
									Cancelar reserva
								</a>
								<a v-if="!isCreator && !reservation.finishedDateTime" :data-bs-target="'#modalCancelAssistance-' + reservation.id" class="btn btn-outline-primary w-100" data-bs-toggle="modal">
									{{ cancelAssistanceButtonText }}
								</a>
								<div v-if="!isCreator && reservation.finishedDateTime || isCreator && reservation.finishedDateTime">
									<b>Reserva finalizada </b>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-lg-8">
					<div class="card-body h-100 align-content-center">
						<div class="alert alert-secondary" id="durationReservationMessage" style="text-wrap: pretty" v-if="reservation.durationLimited">
							{{ durationReservationMessage }}
						</div>
						<div class="card-content-btn">
							<a class="btn btn-whatsapp w-100" :href="shareInvitationLink" target="_blank"><i class="fab fa-whatsapp"></i> Comparte tu reserva</a>
						</div>
						<p class="card-text">Para que cada miembro del grupo tenga su QR.</p>
						<button :id="'id-' + reservation.id" :class="{ 'disabled': reservation.menuAccessEnabled === 0 }" :disabled="reservation.finishedDateTime" class="btn btn-primary w-100" @click="redirectToMenu">
							{{ reservation.finishedDateTime ? 'La reserva ha finalizado' : updateOrderButtonText }}
							<i v-if="reservation.menuAccessEnabled === 0" class="fas fa-lock"></i>
							<i v-else class="fas fa-lock-open"></i>
						</button>
						<p class="card-text">Mostrando el
							<b>QR</b>, todos podrán acceder a la carta digital<!--											 y pedir desde su móvil.-->
						</p>
					</div>
				</div>
			</div>
			<div class="hidden-md">
				<ul class="list-group list-group-flush" style="border-radius: 0">
					<li class="list-group-item">
						<div class="row row-column-gap">
							<template>
								<div v-if="isCreator && !reservation.finishedDateTime && reservation.menuAccessEnabled !== 1" class="col-12">
									<a :data-bs-target="'#modalUpdateReserve-' + reservation.id" class="btn btn-outline-primary w-100" data-bs-toggle="modal">
										Modificar reserva
									</a>
								</div>
							</template>

							<div class="col-6" v-if="shouldRenderCol6()">
								<a v-if="isCreator && !reservation.finishedDateTime && reservation.menuAccessEnabled !== 1" id="btn-cancel-reservation" :data-bs-target="'#modalCancelReserve-' + reservation.id" class="btn btn-outline-primary w-100" data-bs-toggle="modal">
									Cancelar reserva
								</a>
								<a v-if="!isCreator && !reservation.finishedDateTime" :data-bs-target="'#modalCancelAssistance-' + reservation.id" class="btn btn-outline-primary w-100" data-bs-toggle="modal">
									{{ cancelAssistanceButtonText }}
								</a>
								<div v-if="!isCreator && reservation.finishedDateTime || isCreator && reservation.finishedDateTime">
									<b>Reserva finalizada </b>
								</div>
							</div>
							<div class="col">
								<a :data-bs-target="'#modalGoogleMaps-' + reservation.id" data-bs-toggle="modal" class="btn btn-outline-primary w-100 h-100 align-content-center">
									<i class="fas fa-map-marker-alt"></i> Cómo llegar
								</a>
							</div>
						</div>
					</li>

				</ul>
			</div>
		</div>
	</div>

	<!--Todo: Sacamos el modal fuera de la tarjeta hasta que mostremos todas las reservas-->
	<CancelReservationModal :reservation="reservation"></CancelReservationModal>

	<!--Alerts scanner QR-->
	<div class="toast-container position-fixed end-0 p-3" style="top: 60px;">
		<div id="accessToMenuCorrectly" class="toast align-items-center toast-success" role="alert" aria-live="assertive" aria-atomic="true">
			<div class="d-flex">
				<div class="toast-body">
					Ya puedes comenzar a pedir desde tu móvil.
				</div>
				<button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
			</div>
		</div>
		<div id="accessToMenuIncorrectly" class="toast align-items-center toast-danger" role="alert" aria-live="assertive" aria-atomic="true">
			<div class="d-flex">
				<div class="toast-body">
					No se han podido activar tu reserva.
				</div>
				<button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
			</div>
		</div>
	</div>

	<CancelAssistanceModal :reservation="reservation" :key="reservation.id"></CancelAssistanceModal>

	<UpdateReservationModal :reservation="reservation"></UpdateReservationModal>

	<div :id="'modalGoogleMaps-' + reservation.id" aria-hidden="true" aria-labelledby="modalGoogleMap" class="modal fade" tabindex="-1">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="map-container">
						<iframe :src='venueParams.location_gmaps_url' width="600" height="600" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
					</div>
				</div>
				<div class="modal-footer">

					<button class="btn btn-outline-primary" data-bs-dismiss="modal" type="button">Cerrar</button>
				</div>
			</div>
		</div>
	</div>

	<AppModalCentered v-if="showManualRedirectModal" @close="showManualRedirectModal = false" :close="true">
		<template #header>¡Tu carta personalizada te espera!</template>
		<p>
			Pulsa el botón <strong>Comenzar a pedir</strong> para acceder a tu menú digital.
		</p>
		<template #footer>
			<PrimaryButton @click="redirectToMenu">
				Comenzar a pedir
			</PrimaryButton>
		</template>
	</AppModalCentered>
</template>
<script>
import * as bootstrap from 'bootstrap';
import {mapGetters, mapMutations} from "vuex";
import CancelReservationModal from "@/components/mods/cancelReservationModal/CancelReservationModal";
import CancelAssistanceModal from "@/components/mods/cancelAssistanceModal/CancelAssistanceModal";
import UpdateReservationModal from "@/components/mods/updateReservationModal/UpdateReservationModal";
import PrimaryButton from "@/components/ui/buttons/variants/PrimaryButton.vue";
import AppModalCentered from "@/components/ui/modals/AppModalCentered.vue";

export default {
	inject: ['userRepository', 'reservationRepository'],
	props: {
		reservation: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			date: '',
			time: '',
			isMountedComponent: false,
			cancelAssistanceButtonText: 'Cancelar asistencia',
			shareInvitationLink: '',
			invitedUsers: [],
			isCreator: false,
			reservationHost: '',
			promotionDiscountDrink: '',
			isValidateUser: false,
			venueParams: null,
			nameShowQREventClick: 'WeWelcomx',

			textBtnStartOrdering: 'Comenzar a pedir',

			showManualRedirectModal: false,
		};
	},
	watch: {
		user: {
			handler(newUser) {
				this.isValidateUser = newUser.type === 2
			},
			immediate: true
		},
		reservation: {
			handler(res) {
				this.setupData();
				if (res.menuAccessEnabled === 1) {
					this.tryRedirect();
				}
			},
			deep: true,
			immediate: true
		}
	},
	components: {
		AppModalCentered,
		PrimaryButton,
		UpdateReservationModal,
		CancelReservationModal,
		CancelAssistanceModal,
	},
	computed: {
		...mapGetters('user', ['user']),
		...mapGetters('config', ['weWelcomUrl']),

		updateOrderButtonText() {
			if (this.reservation.menuAccessEnabled === 0) {
				return 'Aquí podrás pedir'
			}
			return 'Comenzar a pedir'
		},
		invitedUsersString() {
			if (!this.invitedUsers || this.invitedUsers.length === 0) {
				return 'No hay asistentes';
			}

			let result = '';
			this.invitedUsers.forEach((invited, index) => {
				if (invited.userId === this.user.id) {
					result += 'Tú';
				} else {
					result += invited.name;
				}

				if (index !== this.invitedUsers.length - 1) {
					result += ', ';
				} else {
					result += '.';
				}
			});

			return result;
		},
		displayInvitedUsers() {
			return this.invitedUsers.slice(0, this.reservation.pax).map((invited, index) => {
				// Obtener el nombre del invitado y convertirlo a mayúsculas
				let name = String(invited.userId === this.user.id ? 'Tú' : invited.name);
				if (index === this.reservation.pax - 1 && this.invitedUsers.length > this.reservation.pax) {
					name += '.';
				}
				return name.toUpperCase()
			}).join(', ');
		},

		durationReservationMessage() {
			const start = new Date(this.reservation.startDateTime);
			const end = new Date(this.reservation.endDateTime);

			if (!isNaN(start) && !isNaN(end)) {
				const durationMs = end - start;
				const finalDate = new Date(start.getTime() + durationMs);
				const formattedTime = finalDate.toTimeString().slice(0, 5);

				return `Dispondrás hasta las ${formattedTime} para disfrutar de tu reserva.`;
			}
			return ''
		}
	},

	beforeMount() {
		console.log("Usuario en passreservationcard", this.user)
		this.shareInvitationLink = `https://${this.reservation.venueParams.subdomain}.wewelcom.io` + `/world/api/reservation/whatsappinvitationlink/${this.reservation.id}/${this.user.id}`;

		console.log('Informacion de las reservas', this.reservation)
		// Filtrar usuarios invitados (Creador: type 1), (Invitado: type 2), (Cancelada: type -1)
		this.invitedUsers = this.reservation.reservationUsers.filter(user => user.userId && user.type !== 1 && user.type !== -1);
		console.log('Estos son los datos de invitados', this.invitedUsers)

		this.isCreator = this.reservation.reservationUsers.filter(user => user.userId === this.user.id && user.type === 1).length > 0;
		this.reservationHost = this.reservation.reservationUsers.filter(user => user.type === 1)[0] ? this.reservation.reservationUsers.filter(user => user.type === 1)[0].name : 'Nombre del restaurante';

		this.venueParams = this.reservation.venueParams;
	},
	mounted() {
		this.setupData();
		this.initializeTooltips();
		this.isMountedComponent = true;
		this.promotionDiscountDrink = this.calculateDiscountPercentage(this.reservation.promotion ? this.reservation.promotion.discount : null);
		this.promotionDiscountFood = this.calculateDiscountPercentage();
	},
	methods: {
		...mapMutations('user', ['eraseReservation']),
		setupData() {
			const dateTime = new Date(this.reservation.startDateTime);

			const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
			const nameDay = daysOfWeek[dateTime.getDay()];
			const translator = {
				Sunday: "Dom.",
				Monday: "Lun.",
				Tuesday: "Mar.",
				Wednesday: "Mié.",
				Thursday: "Jue.",
				Friday: "Vie.",
				Saturday: "Sáb.",
			};
			const nameDayTranslated = translator[nameDay];

			const months = {
				Jan: 'Ene',
				Feb: 'Feb',
				Mar: 'Mar',
				Apr: 'Abr',
				May: 'May',
				Jun: 'Jun',
				Jul: 'Jul',
				Aug: 'Ago',
				Sep: 'Sep',
				Oct: 'Oct',
				Nov: 'Nov',
				Dec: 'Dic'
			};
			const month = months[dateTime.toLocaleString('en', {month: 'short'})];
			this.date = `${nameDayTranslated} ${dateTime.getDate()} ${month}`;

			const hours = dateTime.getHours();
			const minutes = dateTime.getMinutes();
			this.time = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
		},
		async qrClicked() {
			let agent = "WELCOM PASS TEST";

			let data = {
				"code": this.user.hostCode,
				"agent": agent,
				"type": 1,
				"text": "Escaneo de pass demo",
			}

			try {
				let reservationVenueSubdomain = this.venueParams.subdomain;
				let checkCodeResponse = await this.userRepository.registerLog(data, reservationVenueSubdomain);
				this.showToast('accessToMenuCorrectly');

				console.log("La respuesta del servidor para el check del código fue ");
				console.log(checkCodeResponse);

			} catch (e) {
				this.showToast('accessToMenuIncorrectly');
				console.log("Error: " + e);
			}
		},
		redirectToMenu() {
			window.location.href = `https://${this.reservation.venueParams.subdomain}.wewelcom.io/menu?r=${this.reservation.id}&uid=${this.user.hostCode}`;
		},

		calculateDiscountPercentage(discount) {
			if (discount !== null && discount !== 0 && discount !== '') {
				return `${discount / 100}%`;
			}
			return null;
		},
		showToast(toastId) {
			const toastElement = document.getElementById(toastId);
			const toastInstance = bootstrap.Toast.getOrCreateInstance(toastElement);
			toastInstance.show();
		},
		openCollapse(elementId) {
			let collapseElement = document.getElementById('collapse' + elementId);
			if (collapseElement) {
				let iconArrow = document.getElementById('iconArrow' + elementId)
				let collapseInstance = bootstrap.Collapse.getInstance(collapseElement);
				if (!collapseInstance) {
					collapseInstance = new bootstrap.Collapse(collapseElement, {
						toggle: false
					});
				}
				if (collapseElement.classList.contains('show')) {
					collapseInstance.hide();
					iconArrow.classList.remove('fa-rotate-180')
				} else {
					collapseInstance.show();
					iconArrow.classList.add('fa-rotate-180')
				}
			}
		},
		initializeTooltips() {
			const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
			tooltipTriggerList.forEach(tooltipTriggerEl => {
				new bootstrap.Tooltip(tooltipTriggerEl);
			});
		},
		shouldRenderCol6() {
			return (this.isCreator && !this.reservation.finishedDateTime && this.reservation.menuAccessEnabled !== 1) ||
				(!this.isCreator && !this.reservation.finishedDateTime) ||
				(!this.isCreator && this.reservation.finishedDateTime) ||
				(this.isCreator && this.reservation.finishedDateTime);
		},

		detectOS() {
			const ua = navigator.userAgent || navigator.vendor || window.opera;
			if (/android/i.test(ua)) {
				return 'Android';
			}
			if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
				return 'iOS';
			}
			return 'other';
		},

		tryRedirect() {
			const os = this.detectOS();
			if (os === 'Android') {
				// en Android simplemente redirige
				this.redirectToMenu();
			} else if (os === 'iOS') {
				// en iOS redirige y muestra tu app-modal
				this.redirectToMenu();
				this.showManualRedirectModal = true;
			} else {
				// otros navegadores, igual redirige
				this.redirectToMenu();
			}
		},
	}
};
</script>

<style scoped>
/* Allow page scroll when pointer/touch is over the card — overflow:hidden on .card
   causes iOS Safari to swallow the pan gesture. Explicitly allowing pan propagates it
   up to the document. Matches the fix applied to EventPassCard. */
.container {
    touch-action: pan-x pan-y;
    overscroll-behavior-y: auto;
}

.card,
:deep(.card-header),
:deep(.card-body),
:deep(.row),
:deep(.list-group-item) {
    touch-action: pan-x pan-y;
    overscroll-behavior-y: auto;
}
</style>
